"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ionValueToJsObject = void 0;
var IonTypes_1 = require("@amzn/amazon-config-store-type-script-ion-parser/dist/IonTypes");
var snakeCaseToCamelCase = function (str) { return str.replace(/_[a-z0-9]/g, function (group) { return group[1].toUpperCase(); }); };
var ionValueToJsObject = function (ionValue) {
    if (ionValue == null)
        return null;
    switch (ionValue.getType()) {
        case IonTypes_1.IonTypes.BLOB:
            return ionValue.toJSON();
        case IonTypes_1.IonTypes.BOOL:
            return ionValue.booleanValue();
        case IonTypes_1.IonTypes.CLOB:
            return ionValue.toJSON();
        case IonTypes_1.IonTypes.DECIMAL:
            return ionValue.numberValue();
        case IonTypes_1.IonTypes.FLOAT:
            return ionValue.numberValue();
        case IonTypes_1.IonTypes.INT:
            return ionValue.numberValue();
        case IonTypes_1.IonTypes.LIST:
            return ionValue.elements().map(exports.ionValueToJsObject);
        case IonTypes_1.IonTypes.NULL:
            return null;
        case IonTypes_1.IonTypes.SEXP:
            return ionValue.elements().map(exports.ionValueToJsObject);
        case IonTypes_1.IonTypes.STRING:
            return ionValue.stringValue();
        case IonTypes_1.IonTypes.STRUCT:
            return ionValue.fields().reduce(function (newObj, _a) {
                var key = _a[0], value = _a[1];
                var camelCaseKey = snakeCaseToCamelCase(key);
                newObj[camelCaseKey] = (0, exports.ionValueToJsObject)(value);
                return newObj;
            }, {});
        case IonTypes_1.IonTypes.SYMBOL:
            return ionValue.stringValue();
        case IonTypes_1.IonTypes.TIMESTAMP:
            return ionValue.toJSON();
        default:
            return null;
    }
};
exports.ionValueToJsObject = ionValueToJsObject;
